{
  "name": "netsyncio",
  "version": "1.1.32",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "test-headless": "ng test --watch=false --browsers=ChromeHeadlessCI",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "doc": "npx compodoc -p tsconfig.json -n \"Netsync documentation\"",
    "show-doc": "npx compodoc -p tsconfig.json -s",
    "push": "npm version patch --no-git-tag-version --force && git add . && git commit -m \"Version Increment\" && git push",
    "start-pwa": "ng build --configuration production && http-server -p 8080 -c-1 dist/netsyncio",
    "test:coverage": "ng test --no-watch --codeCoverage=true --browsers Chrome",
    "coverage": "ng test --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.8",
    "@angular/cdk": "^21.1.0",
    "@angular/common": "^21.0.8",
    "@angular/compiler": "^21.0.8",
    "@angular/core": "^21.0.8",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^21.0.8",
    "@angular/material": "^21.1.0",
    "@angular/platform-browser": "^21.0.8",
    "@angular/platform-browser-dynamic": "^21.0.8",
    "@angular/router": "^21.0.8",
    "@angular/service-worker": "^21.0.8",
    "@fortawesome/angular-fontawesome": "^0.8.1",
    "@fortawesome/fontawesome-svg-core": "^1.2.34",
    "@fortawesome/free-solid-svg-icons": "^5.15.2",
    "@juggle/resize-observer": "^3.3.1",
    "@ng-select/ng-select": "^12.0.7",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "@rxweb/reactive-form-validators": "^2.1.6",
    "@swimlane/ngx-charts": "^23.0.0",
    "@swimlane/ngx-graph": "^11.0.0-alpha.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-shepherd": "^15.0.0",
    "angular-twitter-timeline": "^13.0.0",
    "copy-image-clipboard": "^2.1.2",
    "d3": "^7.9.0",
    "echarts": "^5.6.0",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.12.1",
    "http-server": "^14.1.0",
    "jspdf": "^2.5.1",
    "moment": "^2.29.1",
    "ngx-echarts": "^21.0.0",
    "ngx-image-cropper": "^5.0.1",
    "ngx-owl-carousel-o": "^21.0.0",
    "ngx-pagination": "^6.0.3",
    "node": "^20.17.0",
    "rxjs": "^7.8.2",
    "tailwindcss": "^3.4.17",
    "tslib": "^2.0.0",
    "tslint": "^6.1.3",
    "tslint-angular": "^3.0.3",
    "xlsx": "^0.18.0",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.5",
    "@angular-devkit/schematics": "^20.3.14",
    "@angular-eslint/builder": "12.7.0",
    "@angular-eslint/eslint-plugin": "12.7.0",
    "@angular-eslint/eslint-plugin-template": "12.7.0",
    "@angular-eslint/schematics": "12.7.0",
    "@angular-eslint/template-parser": "12.7.0",
    "@angular/cli": "^21.0.5",
    "@angular/compiler-cli": "^21.0.8",
    "@compodoc/compodoc": "^1.1.11",
    "@fortawesome/fontawesome-free": "^5.15.2",
    "@types/jasmine": "^3.5.14",
    "@types/jasminewd2": "~2.0.3",
    "@types/jspdf": "^1.3.3",
    "@types/node": "^12.19.15",
    "@typescript-eslint/eslint-plugin": "6.7.0",
    "@typescript-eslint/parser": "6.7.0",
    "eslint": "^7.26.0",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "^39.6.4",
    "eslint-plugin-prefer-arrow": "latest",
    "jasmine-core": "~3.5.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.3.17",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "node-bin-setup": "^1.1.0",
    "protractor": "~7.0.0",
    "resize-observer-polyfill": "^1.5.1",
    "ts-node": "~8.3.0",
    "typescript": "~5.9.0"
  }
}
